import { Capacitor } from '@capacitor/core';
import { Camera } from '@capacitor/camera';


export async function getAudioStream(options = { audio: true }) {
 
  await requestCapacitorPermissions(['audio']);
  let audioStream = await navigator.mediaDevices.getUserMedia(options);
  
  return audioStream;
}

export async function getVideoStream() {
  
  await requestCapacitorPermissions(['video']);
  let videoStream = await navigator.mediaDevices.getUserMedia({ video: true });
 
  return videoStream;
}

export async function getAudioVideoStream() {

  await requestCapacitorPermissions(['audio', 'video']);
  let  audioVideoStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
  
  return audioVideoStream;
}

/*async function requestCapacitorPermissions(types) {
  if (Capacitor.getPlatform() === 'android') {
    const { PermissionsAndroid } = await import('@capacitor/android');
    for (const type of types) {
      const permission = type === 'audio' ? 'android.permission.RECORD_AUDIO' : 'android.permission.CAMERA';
      const result = await PermissionsAndroid.requestPermission({ permission });
      if (!result.granted) {
        throw new Error(`${type} permission denied`);
      }
    }
  }
}
async function requestCapacitorPermissions(types) {
  if (Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'ios') {
    for (const type of types) {
      const permissionName = type === 'audio' ? 'microphone' : 'camera';

      const status = await Permissions.query({ name: permissionName });
      if (status.state !== 'granted') {
        const result = await Permissions.request({ name: permissionName });
        if (result.state !== 'granted') {
          throw new Error(`${permissionName} permission denied`);
        }
      }
    }
  }
}
export async function requestCapacitorPermissions(types) {
  if (Capacitor.getPlatform() !== 'android' && Capacitor.getPlatform() !== 'ios') return;

  for (const type of types) {
    const permissionName = type === 'audio' ? 'microphone' : 'camera';

    const check = await Camera.checkPermissions();
    const needs = check[permissionName];

    if (needs !== 'granted') {
      const result = await Camera.requestPermissions({ permissions: [permissionName] });
      if (result[permissionName] !== 'granted') {
        throw new Error(`${permissionName} permission denied`);
      }
    }
  }
}
*/
const PERMISSION_MAP = {
  audio: 'microphone',
  video: 'camera',
};
const VALID_ALIASES = Object.keys(PERMISSION_MAP);
export async function requestCapacitorPermissions(aliases = []) {
  if (Capacitor.getPlatform() !== 'android' && Capacitor.getPlatform() !== 'ios') return;

  const needsAudio = aliases.includes('audio');
  const needsVideo = aliases.includes('video');

  try {
    // ✅ Request camera permission (video) via Capacitor
    if (needsVideo) {
      const camCheck = await Camera.checkPermissions();
      if (camCheck.camera !== 'granted') {
        const result = await Camera.requestPermissions({ permissions: ['camera'] });
        if (result.camera !== 'granted') {
          throw new Error('Camera permission denied');
        }
      }
    }

    // ✅ Trigger mic permission via getUserMedia
    if (needsAudio) {
      // This will automatically show mic prompt if needed
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      // Immediately stop the stream after permission is granted
      stream.getTracks().forEach(track => track.stop());
    }

  } catch (err) {
    console.error('[mediaAccess] Permission error:', err.message);
    throw err; // Optional: rethrow if you want the caller to handle it
  }
}
